import React from 'react';

function FilterSelect({ label, name, value, onChange, options }) {
  return (
    <div className="page-filters__item">
      <label className="page-filters__label-inline" htmlFor={`filter-${name}`}>
        {label}
      </label>
      <select
        id={`filter-${name}`}
        name={name}
        value={value}
        onChange={onChange}
        className="page-filters__select"
      >
        {options}
      </select>
    </div>
  );
}

export default function PageFilters({ filters, handleFilterChange, publications, sites }) {
  return (
    <div className="page-filters">
      {publications && publications.length > 0 && (
        <FilterSelect
          label="Publication"
          name="publicationId"
          value={filters.publicationId || ''}
          onChange={handleFilterChange}
          options={[
            <option key="all" value="">
              All Publications
            </option>,
            ...publications.map((p) => (
              <option key={p.id} value={p.id}>
                {p.label ?? p.title ?? p.name}
              </option>
            ))
          ]}
        />
      )}
      {sites && sites.length > 0 && (
        <FilterSelect
          label="Site"
          name="siteId"
          value={filters.siteId || ''}
          onChange={handleFilterChange}
          options={[
            <option key="all" value="">
              All Sites
            </option>,
            ...sites.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))
          ]}
        />
      )}
    </div>
  );
}
